import React , { useState, useEffect, useRef, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faSearch} from '@fortawesome/free-solid-svg-icons'
import { faBars} from '@fortawesome/free-solid-svg-icons'
import logo from '../Images/logo-main-white.png'


import profilePictureContImage from '../Images/defprofile.png'

import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { collection, getDocs, onSnapshot, query, where } from "firebase/firestore";
import { db } from '../firebase';

//routers
import {useNavigate } from "react-router-dom";
import {Link, NavLink } from "react-router-dom";

//mobile navbar
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

//icons
import { faHome} from '@fortawesome/free-solid-svg-icons'
import { faUser} from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay} from '@fortawesome/free-solid-svg-icons'
import { faUsd} from '@fortawesome/free-solid-svg-icons'
import { faVideoCamera} from '@fortawesome/free-solid-svg-icons'
import { faBicycle } from '@fortawesome/free-solid-svg-icons';
import { faMagic, faUserCheck } from '@fortawesome/free-solid-svg-icons';

import { getDatabase, ref, onValue } from 'firebase/database';
import useTopbarProfile from './useTopbarProfile';
import { buildCourseKey, buildInvoicesForCourse, normalizeCourseName } from '../Dashboard/invoiceSchedule';
import useInterviewMenuAccess from './useInterviewMenuAccess';

const normalizeSearchValue = (value) => (value || "").toString().trim().toLowerCase();
const getSearchTokens = (value) => normalizeSearchValue(Array.isArray(value) ? value.join(" ") : value);
const MESSAGE_SUMMARY_CACHE_KEY = "ubunifu-student-message-summary-v1";
const normalizeTimestamp = (value) => {
  if (!value) return 0;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.seconds === "number") return value.seconds * 1000;
  return new Date(value).getTime() || 0;
};

const readMessageSummaryCache = (userId) => {
  if (typeof window === "undefined" || !userId) return null;
  try {
    const rawCache = window.sessionStorage.getItem(MESSAGE_SUMMARY_CACHE_KEY);
    if (!rawCache) return null;
    const parsed = JSON.parse(rawCache);
    return parsed?.[userId] || null;
  } catch (error) {
    return null;
  }
};

const writeMessageSummaryCache = (userId, value) => {
  if (typeof window === "undefined" || !userId) return;
  try {
    const rawCache = window.sessionStorage.getItem(MESSAGE_SUMMARY_CACHE_KEY);
    const parsed = rawCache ? JSON.parse(rawCache) : {};
    parsed[userId] = value;
    window.sessionStorage.setItem(MESSAGE_SUMMARY_CACHE_KEY, JSON.stringify(parsed));
  } catch (error) {
    // Ignore cache failures and rely on live updates.
  }
};

function Dashnav() {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchProfileData, setSearchProfileData] = useState({
    admissionNumber: "",
    course: "",
    userStatus: "",
  });
  const [searchCourseEntries, setSearchCourseEntries] = useState([]);
  const [searchInvoices, setSearchInvoices] = useState([]);
  const [searchAttendance, setSearchAttendance] = useState([]);
  const [searchMessageContacts, setSearchMessageContacts] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [isMessagesOpen, setIsMessagesOpen] = useState(false);
  const [dueNotifications, setDueNotifications] = useState([]);
  const [assignmentNotifications, setAssignmentNotifications] = useState([]);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const searchDropdownRef = useRef(null);
  const messagesDropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);

  //instantiate auth
  const auth = getAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const realtimeDb = getDatabase();
  const hasInterviewMenuAccess = useInterviewMenuAccess();
  const { profilePic: userProfilePicture } = useTopbarProfile({
    profileCollection: 'users',
    profileIdField: 'userId',
    expectedUserType: 'student',
    redirectPath: '/in/dashboard',
    fallbackImage: profilePictureContImage,
  });

  let navigate = useNavigate();
  function goToProfile(){
    setIsProfileMenuOpen(false);
    navigate("/profile")
  }

  const formatSearchDate = (value) => {
    if (!value) return "";
    const parsed = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(parsed.getTime())) return "";
    return parsed.toLocaleDateString("en-KE", {
      day: "numeric",
      month: "short",
      year: "numeric",
      });
  };

  const closeSearchDropdown = () => {
    setIsSearchOpen(false);
  };

  const openSearchResult = (result) => {
    closeSearchDropdown();
    setSearchTerm("");

    if (result.kind === "message") {
      openMessageThread({
        userId: result.userId,
        name: result.title,
        avatar: result.avatar,
        course: result.course,
      });
      return;
    }

    if (typeof result.onSelect === "function") {
      result.onSelect();
    }
  };

  function goToEditProfile(){
    setIsProfileMenuOpen(false);
    navigate("/edit-profile");
  }

  async function handleLogout() {
    setIsProfileMenuOpen(false);
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }

  function openMessageThread(message) {
    setIsMessagesOpen(false);
    navigate("/workspace", {
      state: {
        openDMUserId: message.userId,
        openDMName: message.name,
        openDMAvatar: message.avatar || profilePictureContImage,
        openDMCourse: message.course || "",
      },
    });
  }

  function goToFeeInvoices(notification) {
    setIsNotificationOpen(false);

    if (notification?.type === "secondary") {
      navigate("/fee-invoices", {
        state: {
          secondaryCourse: {
            name: notification.courseName,
            intakeId: notification.intakeId || "",
            intakeDate: notification.intakeDate || "",
            rawIntakeDate: notification.rawIntakeDate || "",
            status: notification.courseStatus || "Pending",
            admissionDate: notification.admissionDate || "",
          }
        }
      });
      return;
    }

    navigate("/fee-invoices");
  }

  function openAssignmentNotification(notification) {
    setIsNotificationOpen(false);
    navigate("/course-details", {
      state: {
        courseName: notification.courseName,
        tab: "assessments",
        openAssignmentId: notification.assignmentId,
      }
    });
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!searchDropdownRef.current?.contains(event.target)) {
        setIsSearchOpen(false);
      }
      if (!messagesDropdownRef.current?.contains(event.target)) {
        setIsMessagesOpen(false);
      }
      if (!notificationDropdownRef.current?.contains(event.target)) {
        setIsNotificationOpen(false);
      }
      if (!profileDropdownRef.current?.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
  useEffect(() => {
    let unsubscribeRealtime = () => {};

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribeRealtime();
      setUnreadMessages([]);
      setSearchMessageContacts([]);
      setUnreadCount(0);

      if (!user) return;

      const cachedMessageSummary = readMessageSummaryCache(user.uid);
      if (cachedMessageSummary) {
        setUnreadCount(Number(cachedMessageSummary.count) || 0);
        setUnreadMessages(Array.isArray(cachedMessageSummary.items) ? cachedMessageSummary.items : []);
      }

      const userId = user.uid;
      const chatsRef = ref(realtimeDb, 'chats');

      unsubscribeRealtime = onValue(chatsRef, async (snapshot) => {
        if (!snapshot.exists()) {
          setUnreadCount(0);
          setUnreadMessages([]);
          setSearchMessageContacts([]);
          writeMessageSummaryCache(userId, {
            count: 0,
            items: [],
            updatedAt: Date.now(),
          });
          return;
        }

        let count = 0;
        const allChats = snapshot.val();
        const unreadByUser = {};
        const latestByUser = {};
        const seenMessageIds = new Set();

        Object.entries(allChats).forEach(([chatId, messagesObj]) => {
          if (!chatId.split('_').includes(userId)) return;

          Object.entries(messagesObj || {}).forEach(([messageKey, msg]) => {
            const uniqueKey = msg.messageId || messageKey;
            if (seenMessageIds.has(uniqueKey)) return;
            seenMessageIds.add(uniqueKey);

            const otherUserId = chatId
              .replace(`${userId}_`, '')
              .replace(`_${userId}`, '');
            const messageTimestamp = typeof msg.clientTimestamp === "number"
              ? msg.clientTimestamp
              : (msg.timestamp?.seconds ? msg.timestamp.seconds * 1000 : 0);

            if (msg.receiverId === userId && msg.isRead === false) {
              count += 1;

              if (!unreadByUser[otherUserId]) {
                unreadByUser[otherUserId] = {
                  userId: otherUserId,
                  unreadCount: 0,
                  lastMessage: msg.text || "",
                  lastTimestamp: messageTimestamp,
                };
              }

              unreadByUser[otherUserId].unreadCount += 1;
              if (messageTimestamp >= unreadByUser[otherUserId].lastTimestamp) {
                unreadByUser[otherUserId].lastMessage = msg.text || "";
                unreadByUser[otherUserId].lastTimestamp = messageTimestamp;
              }
            }

            if (otherUserId) {
              if (!latestByUser[otherUserId] || messageTimestamp >= latestByUser[otherUserId].lastTimestamp) {
                latestByUser[otherUserId] = {
                  userId: otherUserId,
                  preview: msg.text || "",
                  lastTimestamp: messageTimestamp,
                };
              }
            }
          });
        });

        setUnreadCount(count);

        const latestEntries = Object.values(latestByUser).sort((left, right) => right.lastTimestamp - left.lastTimestamp);
        if (latestEntries.length === 0) {
          setUnreadMessages([]);
          setSearchMessageContacts([]);
          writeMessageSummaryCache(userId, {
            count,
            items: [],
            updatedAt: Date.now(),
          });
          return;
        }

        const placeholderContacts = latestEntries.map((entry) => ({
          userId: entry.userId,
          name: "Conversation",
          avatar: profilePictureContImage,
          course: "",
          unreadCount: unreadByUser[entry.userId]?.unreadCount || 0,
          preview: unreadByUser[entry.userId]?.lastMessage || entry.preview || "",
          timestamp: entry.lastTimestamp,
        }));

        setSearchMessageContacts(placeholderContacts);
        setUnreadMessages(
          placeholderContacts.filter((entry) => entry.unreadCount > 0)
        );
        writeMessageSummaryCache(userId, {
          count,
          items: placeholderContacts.filter((entry) => entry.unreadCount > 0),
          updatedAt: Date.now(),
        });

        try {
          const resolvedContacts = await Promise.all(
            latestEntries.map(async (entry) => {
              const userSnapshot = await getDocs(
                query(collection(db, 'users'), where('userId', '==', entry.userId))
              );

              if (!userSnapshot.empty) {
                const userDoc = userSnapshot.docs[0]?.data() || {};
                return {
                  userId: entry.userId,
                  name: userDoc.bio || userDoc.userName || "Student",
                  avatar: userDoc.profilePic || profilePictureContImage,
                  course: userDoc.course || "",
                  unreadCount: unreadByUser[entry.userId]?.unreadCount || 0,
                  preview: unreadByUser[entry.userId]?.lastMessage || entry.preview || "",
                  timestamp: entry.lastTimestamp,
                };
              }

              const employeeSnapshot = await getDocs(
                query(collection(db, 'Employees'), where('docId', '==', entry.userId))
              );
              const employeeDoc = employeeSnapshot.docs[0]?.data() || {};

              return {
                userId: entry.userId,
                name: employeeDoc.employeeName || "Instructor",
                avatar: employeeDoc.profilePic || profilePictureContImage,
                course: employeeDoc.role || "Instructor",
                unreadCount: unreadByUser[entry.userId]?.unreadCount || 0,
                preview: unreadByUser[entry.userId]?.lastMessage || entry.preview || "",
                timestamp: entry.lastTimestamp,
              };
            })
          );

          setSearchMessageContacts(resolvedContacts);
          setUnreadMessages(
            resolvedContacts.filter((entry) => entry.unreadCount > 0)
          );
          writeMessageSummaryCache(userId, {
            count,
            items: resolvedContacts.filter((entry) => entry.unreadCount > 0),
            updatedAt: Date.now(),
          });
        } catch (error) {
          // Keep placeholder contacts if profile resolution fails.
        }
      });
    });

    return () => {
      unsubscribeRealtime();
      unsubscribe();
    };
  }, [auth, realtimeDb]);

  useEffect(() => {
    let unsubscribeUser = () => {};
    let unsubscribeAssignments = () => {};
    let unsubscribeReads = () => {};

    const formatAssignmentDate = (value) => {
      const timestamp = normalizeTimestamp(value);
      if (!timestamp) return "";
      return new Intl.DateTimeFormat("en-KE", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(new Date(timestamp));
    };

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      unsubscribeUser();
      unsubscribeAssignments();
      unsubscribeReads();

      if (!user) {
        setAssignmentNotifications([]);
        return;
      }

      let latestUserData = null;
      let latestAssignments = [];
      let latestReadIds = new Set();

      const updateAssignmentNotifications = () => {
        if (!latestUserData) {
          setAssignmentNotifications([]);
          return;
        }

        const normalizedSecondary = Array.isArray(latestUserData.secondaryCourses)
          ? latestUserData.secondaryCourses.map((entry) => (
            typeof entry === "string"
              ? { name: entry }
              : { name: entry?.name || entry?.courseName || "" }
          )).filter((entry) => entry.name)
          : [];

        const courseKeys = new Set(
          [
            latestUserData.course,
            latestUserData.currentCourse,
            latestUserData.program,
            latestUserData.courseName,
            ...normalizedSecondary.map((entry) => entry.name),
          ]
            .map(normalizeCourseName)
            .filter(Boolean)
        );

        const unreadAssignments = latestAssignments
          .filter((assignment) => {
            const assignmentStudentIds = Array.isArray(assignment.studentIds)
              ? assignment.studentIds.map((studentId) => String(studentId))
              : [];
            const assignmentCourseKey = normalizeCourseName(assignment.courseKey || assignment.courseName || assignment.courseId);
            const matchesStudent = (
              normalizeCourseName(assignment.audience) === "all" ||
              assignmentStudentIds.length === 0 ||
              assignmentStudentIds.includes(user.uid)
            );
            const matchesCourse = courseKeys.size === 0 || courseKeys.has(assignmentCourseKey);

            return matchesStudent && (matchesCourse || assignmentStudentIds.includes(user.uid));
          })
          .filter((assignment) => !latestReadIds.has(assignment.id))
          .sort((left, right) => (
            normalizeTimestamp(right.createdAtMs || right.createdAt || right.updatedAtMs || right.updatedAt)
            - normalizeTimestamp(left.createdAtMs || left.createdAt || left.updatedAtMs || left.updatedAt)
          ))
          .map((assignment) => ({
            id: `assignment-${assignment.id}`,
            assignmentId: assignment.id,
            title: assignment.title || "Assignment",
            courseName: assignment.courseName || latestUserData.course || "Course",
            typeLabel: assignment.assignmentTypeLabel || "Assignment",
            dueLabel: formatAssignmentDate(assignment.dueDate),
            createdLabel: formatAssignmentDate(assignment.createdAtMs || assignment.createdAt || assignment.updatedAtMs || assignment.updatedAt),
            message: assignment.dueDate
              ? `Open this assignment before ${formatAssignmentDate(assignment.dueDate)}.`
              : "Open this assignment to read the full brief and submission instructions."
          }));

        setAssignmentNotifications(unreadAssignments);
      };

      const userQuery = query(collection(db, "users"), where("userId", "==", user.uid));
      unsubscribeUser = onSnapshot(userQuery, (snapshot) => {
        latestUserData = snapshot.empty ? null : snapshot.docs[0].data();
        updateAssignmentNotifications();
      });

      unsubscribeAssignments = onSnapshot(collection(db, "courseAssignments"), (snapshot) => {
        latestAssignments = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
        updateAssignmentNotifications();
      });

      unsubscribeReads = onSnapshot(
        query(collection(db, "studentAssignmentReads"), where("studentId", "==", user.uid)),
        (snapshot) => {
          latestReadIds = new Set(
            snapshot.docs
              .map((docSnap) => docSnap.data()?.assignmentId)
              .filter(Boolean)
          );
          updateAssignmentNotifications();
        }
      );
    });

    return () => {
      unsubscribeUser();
      unsubscribeAssignments();
      unsubscribeReads();
      unsubscribeAuth();
    };
  }, [auth, navigate]);

  const formatMessagePreview = (htmlText) => {
    if (!htmlText) return "";
    if (typeof window === "undefined") return htmlText;
    const temp = document.createElement("div");
    temp.innerHTML = htmlText;
    return (temp.textContent || temp.innerText || "").replace(/\s+/g, " ").trim();
  };

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return "";
    return new Date(timestamp).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const totalNotificationCount = dueNotifications.length + assignmentNotifications.length;

  useEffect(() => {
    let unsubscribeUser = () => {};
    let unsubscribeIncome = () => {};
    let unsubscribeCourses = () => {};

    const buildNotificationMessage = (invoice, daysUntilDue) => {
      const prefix = invoice.status === "Partially Paid"
        ? "Your invoice is partially paid and"
        : "Your invoice is";

      if (daysUntilDue < 0) {
        const overdueDays = Math.abs(daysUntilDue);
        return `${prefix} overdue by ${overdueDays} day${overdueDays === 1 ? "" : "s"}.`;
      }

      if (daysUntilDue === 0) {
        return `${prefix} due today.`;
      }

      if (daysUntilDue === 1) {
        return `${prefix} due tomorrow.`;
      }

      return `${prefix} due in ${daysUntilDue} days.`;
    };

    const formatDueDate = (value) => {
      if (!value) return "";
      return new Intl.DateTimeFormat("en-KE", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(value);
    };

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      unsubscribeUser();
      unsubscribeIncome();
      unsubscribeCourses();

      if (!user) {
        setDueNotifications([]);
        setSearchProfileData({
          admissionNumber: "",
          course: "",
          userStatus: "",
        });
        setSearchCourseEntries([]);
        setSearchInvoices([]);
        return;
      }

      let latestUserData = null;
      let latestCourseCatalog = {};
      let latestPayments = {};

      const updateNotifications = () => {
        if (!latestUserData) {
          setDueNotifications([]);
          setSearchProfileData({
            admissionNumber: "",
            course: "",
            userStatus: "",
          });
          setSearchCourseEntries([]);
          setSearchInvoices([]);
          return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const primaryAdmissionStatus = latestUserData.userStatus === "Student" && latestUserData.Status === "Active"
          ? "Active"
          : "Pending";

        const normalizedSecondary = Array.isArray(latestUserData.secondaryCourses)
          ? latestUserData.secondaryCourses.map((entry) => {
            if (typeof entry === "string") {
              return { name: entry, status: "Pending" };
            }
            return {
              name: entry?.name || entry?.courseName || "",
              intakeId: entry?.intakeId || "",
              intakeDate: entry?.intakeDate || entry?.intake || "",
              rawIntakeDate: entry?.rawIntakeDate || "",
              status: entry?.status || "Pending",
              admissionDate: entry?.admissionDate || "",
            };
          }).filter((entry) => entry.name)
          : [];

        const courseEntries = [];

        if (latestUserData.course) {
          courseEntries.push({
            key: buildCourseKey(latestUserData.course),
            type: "primary",
            name: latestUserData.course,
            status: primaryAdmissionStatus,
            admissionDate: latestUserData.admissionDate || "",
          });
        }

        normalizedSecondary.forEach((entry) => {
          courseEntries.push({
            key: buildCourseKey(entry.name, entry.intakeId, entry.rawIntakeDate),
            type: "secondary",
            name: entry.name,
            status: entry.status,
            admissionDate: entry.admissionDate || "",
            intakeId: entry.intakeId || "",
            intakeDate: entry.intakeDate || "",
            rawIntakeDate: entry.rawIntakeDate || "",
          });
        });

        const notifications = [];
        const invoiceSearchItems = [];

        courseEntries.forEach((courseEntry) => {
          const courseKey = normalizeCourseName(courseEntry.name);
          const courseData = latestCourseCatalog[courseKey];
          if (!courseData) {
            return;
          }

          const payments = latestPayments[courseKey] || { totalPaid: 0 };
          const invoiceList = buildInvoicesForCourse(courseData, payments.totalPaid, {
            admissionDate: courseEntry.admissionDate,
            courseStatus: courseEntry.status,
          });

          invoiceList.forEach((invoice) => {
            const dueDate = invoice.dueDate ? new Date(invoice.dueDate) : null;
            if (dueDate) {
              dueDate.setHours(0, 0, 0, 0);
            }

            invoiceSearchItems.push({
              id: `${courseEntry.key}-${invoice.month}`,
              type: courseEntry.type,
              courseName: courseEntry.name,
              courseStatus: courseEntry.status,
              intakeId: courseEntry.intakeId || "",
              intakeDate: courseEntry.intakeDate || "",
              rawIntakeDate: courseEntry.rawIntakeDate || "",
              admissionDate: courseEntry.admissionDate || "",
              month: invoice.month,
              status: invoice.status,
              dueDate,
              dueLabel: formatDueDate(dueDate),
              balance: invoice.balance,
              expectedAmount: invoice.expectedAmount,
            });

            if (!invoice.dueDate || invoice.status === "Paid" || invoice.status === "Pending") {
              return;
            }
            const daysUntilDue = Math.ceil((dueDate.getTime() - today.getTime()) / 86400000);

            if (daysUntilDue > 5) {
              return;
            }

            notifications.push({
              id: `${courseEntry.key}-${invoice.month}`,
              type: courseEntry.type,
              courseName: courseEntry.name,
              courseStatus: courseEntry.status,
              intakeId: courseEntry.intakeId || "",
              intakeDate: courseEntry.intakeDate || "",
              rawIntakeDate: courseEntry.rawIntakeDate || "",
              admissionDate: courseEntry.admissionDate || "",
              month: invoice.month,
              status: invoice.status,
              dueDate,
              balance: invoice.balance,
              message: buildNotificationMessage(invoice, daysUntilDue),
              dueLabel: formatDueDate(dueDate),
            });
          });
        });

        notifications.sort((left, right) => left.dueDate - right.dueDate);
        setDueNotifications(notifications);
        setSearchProfileData({
          admissionNumber: latestUserData.admissionNumber ? String(latestUserData.admissionNumber) : "",
          course: latestUserData.course || "",
          userStatus: latestUserData.userStatus || latestUserData.Status || "",
        });
        setSearchCourseEntries(courseEntries);
        setSearchInvoices(invoiceSearchItems);
      };

      const userQuery = query(collection(db, "users"), where("userId", "==", user.uid));
      unsubscribeUser = onSnapshot(userQuery, (snapshot) => {
        latestUserData = snapshot.empty ? null : snapshot.docs[0].data();
        updateNotifications();
      });

      unsubscribeCourses = onSnapshot(collection(db, "courses"), (snapshot) => {
        const nextCatalog = {};
        snapshot.forEach((docSnap) => {
          const data = docSnap.data();
          const name = data.mcourseName || data.courseName || data.name;
          if (!name) return;
          nextCatalog[normalizeCourseName(name)] = {
            name,
            feeDeposit: +data.feeDeposit || 0,
            feeInstallments: +data.feeInstallments || 0,
            mcoursePrice: +data.mcoursePrice || 0,
            mcourseDuration: +data.courseDuration || +data.mcourseDuration || 0,
            durationLabel: data.mcourseDuration || data.courseDuration || ""
          };
        });
        latestCourseCatalog = nextCatalog;
        updateNotifications();
      });

      const incomeQuery = query(collection(db, "Income"), where("studentId", "==", user.uid));
      unsubscribeIncome = onSnapshot(incomeQuery, (snapshot) => {
        const nextPayments = {};
        const fallbackCourse = latestUserData?.course || "";

        snapshot.forEach((docSnap) => {
          const data = docSnap.data();
          const amount = parseInt(data.incomeAmount, 10) || 0;
          const paymentCourse = data.courseName || data.course || data.theCourseName || fallbackCourse;
          const courseKey = normalizeCourseName(paymentCourse || fallbackCourse);
          if (!nextPayments[courseKey]) {
            nextPayments[courseKey] = { totalPaid: 0 };
          }
          nextPayments[courseKey].totalPaid += amount;
        });

        latestPayments = nextPayments;
        updateNotifications();
      });
    });

    return () => {
      unsubscribeUser();
      unsubscribeIncome();
      unsubscribeCourses();
      unsubscribeAuth();
    };
  }, [auth, navigate]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setSearchAttendance([]);
        return;
      }

      try {
        const attendanceQuery = query(collection(db, "AttendaceReport"), where("userId", "==", user.uid));
        const snapshot = await getDocs(attendanceQuery);
        const nextAttendance = snapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
            const startTime = data.signInTime?.toDate?.() || data.startTime?.toDate?.();
            if (!startTime) return null;
            const mode = data.mode || data.attendanceMode || (data.roomlink ? "Online" : "Onsite");
            const status = data.status || (data.signOutTime || data.endTime ? "Present" : "Ongoing");
            const sessionTitle = data.sessionTitle || data.className || "Class Session";
            return {
              id: docSnap.id,
              title: sessionTitle,
              mode,
              status,
              dateLabel: formatSearchDate(startTime),
              timestamp: startTime.getTime(),
            };
          })
          .filter(Boolean)
          .sort((left, right) => right.timestamp - left.timestamp)
          .slice(0, 12);

        setSearchAttendance(nextAttendance);
      } catch (error) {
        console.error("Failed to load attendance search data:", error);
        setSearchAttendance([]);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const pageSearchItems = useMemo(() => {
    const admissionNumber = searchProfileData.admissionNumber || "";
    const courseName = searchProfileData.course || "";
    const status = searchProfileData.userStatus || "";

    const pageItems = [
      {
        id: "page-dashboard",
        group: "Pages",
        kind: "page",
        title: "Dashboard",
        description: "Open your main student dashboard",
        searchText: `dashboard home overview`,
        onSelect: () => navigate("/dashboard"),
      },
      {
        id: "page-courses",
        group: "Pages",
        kind: "page",
        title: "My Courses",
        description: courseName ? `Open your course area for ${courseName}` : "Open your courses",
        searchText: `my courses course academic ${courseName}`,
        onSelect: () => navigate("/academic"),
      },
      {
        id: "page-invoices",
        group: "Pages",
        kind: "page",
        title: "Fee Invoices",
        description: "Check invoice months, balances, and due dates",
        searchText: `fee invoices payments due receipt balance month`,
        onSelect: () => navigate("/fee-invoices"),
      },
      {
        id: "page-attendance",
        group: "Pages",
        kind: "page",
        title: "Attendance Report",
        description: "Review online and on-site attendance records",
        searchText: `attendance report class sessions onsite online present absent`,
        onSelect: () => navigate("/class-reports"),
      },
      {
        id: "page-school-id",
        group: "Pages",
        kind: "page",
        title: "School ID",
        description: admissionNumber ? `Open your school ID for ${admissionNumber}` : "Open your school ID",
        searchText: `school id student id admission number certificate verification ${admissionNumber}`,
        onSelect: () => navigate("/student-id"),
      },
      {
        id: "page-profile",
        group: "Pages",
        kind: "page",
        title: "Profile",
        description: status ? `Open your profile and account details (${status})` : "Open your profile and account details",
        searchText: `profile account my account edit account document verification certificate id ${admissionNumber} ${status}`,
        onSelect: () => navigate("/profile"),
      },
    ];

    if (hasInterviewMenuAccess) {
      pageItems.splice(1, 0, {
        id: "page-interviews",
        group: "Pages",
        kind: "page",
        title: "Interviews",
        description: "Open your admissions interview page and join your scheduled session",
        searchText: `interview admissions meeting join suitability video call`,
        onSelect: () => navigate("/interviews"),
      });
    }

    return pageItems;
  }, [hasInterviewMenuAccess, navigate, searchProfileData.admissionNumber, searchProfileData.course, searchProfileData.userStatus]);

  const groupedSearchResults = useMemo(() => {
    const queryValue = normalizeSearchValue(searchTerm);
    if (!queryValue) return [];

    const matchesQuery = (value) => getSearchTokens(value).includes(queryValue);

    const pageResults = pageSearchItems
      .filter((item) => matchesQuery(`${item.title} ${item.description} ${item.searchText}`))
      .map((item) => ({
        ...item,
      }));

    const courseResults = searchCourseEntries
      .filter((entry) => matchesQuery([
        entry.name,
        entry.type,
        entry.status,
        entry.intakeDate,
        entry.admissionDate,
      ]))
      .map((entry) => ({
        id: `course-${entry.key}`,
        group: "Courses",
        kind: "course",
        title: entry.name,
        description: `${entry.type === "secondary" ? "Secondary course" : "Main course"} • ${entry.status || "Pending"}`,
        meta: entry.intakeDate ? `Intake ${entry.intakeDate}` : (entry.admissionDate ? `Admitted ${formatSearchDate(entry.admissionDate)}` : ""),
        onSelect: () => navigate("/course-details", { state: { courseName: entry.name } }),
      }));

    const invoiceResults = searchInvoices
      .filter((invoice) => matchesQuery([
        invoice.month,
        invoice.courseName,
        invoice.status,
        invoice.dueLabel,
        "invoice",
        "payment",
      ]))
      .map((invoice) => ({
        id: `invoice-${invoice.id}`,
        group: "Invoices",
        kind: "invoice",
        title: `${invoice.month} invoice`,
        description: `${invoice.courseName} • ${invoice.status}`,
        meta: invoice.dueLabel ? `Due ${invoice.dueLabel}` : "Due date pending",
        onSelect: () => navigate("/fee-invoices"),
      }));

    const attendanceResults = searchAttendance
      .filter((entry) => matchesQuery([
        entry.title,
        entry.mode,
        entry.status,
        entry.dateLabel,
        "attendance",
        "session",
      ]))
      .map((entry) => ({
        id: `attendance-${entry.id}`,
        group: "Attendance",
        kind: "attendance",
        title: entry.title,
        description: `${entry.mode} • ${entry.status}`,
        meta: entry.dateLabel,
        onSelect: () => navigate("/class-reports"),
      }));

    const messageResults = searchMessageContacts
      .filter((contact) => matchesQuery([
        contact.name,
        contact.course,
        formatMessagePreview(contact.preview),
        "workspace",
        "message",
      ]))
      .map((contact) => ({
        id: `message-${contact.userId}`,
        group: "Messages",
        kind: "message",
        title: contact.name,
        description: formatMessagePreview(contact.preview) || contact.course || "Open conversation",
        meta: contact.unreadCount > 0
          ? `${contact.unreadCount} unread`
          : (contact.timestamp ? formatMessageTime(contact.timestamp) : ""),
        userId: contact.userId,
        avatar: contact.avatar,
        course: contact.course,
      }));

    const grouped = [
      { name: "Pages", items: pageResults.slice(0, 5) },
      { name: "Courses", items: courseResults.slice(0, 4) },
      { name: "Invoices", items: invoiceResults.slice(0, 4) },
      { name: "Attendance", items: attendanceResults.slice(0, 4) },
      { name: "Messages", items: messageResults.slice(0, 4) },
    ].filter((group) => group.items.length > 0);

    return grouped;
  }, [
    searchTerm,
    pageSearchItems,
    searchCourseEntries,
    searchInvoices,
    searchAttendance,
    searchMessageContacts,
    navigate,
  ]);

  const flatSearchResults = useMemo(() => {
    return groupedSearchResults.flatMap((group) => group.items);
  }, [groupedSearchResults]);



  return (
    <div className='dashNav'> 
        <div className='dashMenuIcon'>
          {/* <FontAwesomeIcon icon={faBars} className="dashNavIco "/> */}

          {[false, ].map((expand) => (
            <Navbar key={expand} bg="" className="" expand={expand} >
              <Container fluid>
              
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} className="dashMobileToggle">
                  <FontAwesomeIcon icon={faBars} className="dashMobileToggleIcon" />
                </Navbar.Toggle>
                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand-${expand}`}
                  aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                  placement="start"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <img src={logo} alt="" className='dashnavLogo' />
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav className="justify-content-end flex-grow-1 pe-3">

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/dashboard" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faHome} className="laftNavIcon"/>
                          Dashboard
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/academic" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faBicycle} className="laftNavIcon"/>
                          My Courses
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/my-rooms" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faVideoCamera} className="laftNavIcon"/>
                          Live Classes
                        </Link>
                      </div>

                      {hasInterviewMenuAccess && (
                        <div className='leftLinkCont d-flex align-items-center'>
                          <Link to="/interviews" className='leftNavLinks '>
                            <FontAwesomeIcon icon={faCalendarDay} className="laftNavIcon"/>
                            Interviews
                          </Link>
                        </div>
                      )}

                      {/* <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/ubunifu-firefly" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faMagic} className="laftNavIcon"/>
                          Ubunifu Firefly
                        </Link>
                      </div> */}

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/firefly-reports" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faFileInvoice} className="laftNavIcon"/>
                          My Firefly Reports
                        </Link>
                      </div>

                      <hr />

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/fee-invoices" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faFileInvoice} className="laftNavIcon "/>
                          Fee Invoices
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/fee-report" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faUsd} className="laftNavIcon "/>
                          Fee Payments
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/class-reports" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faCalendarDay} className="laftNavIcon "/>
                          Attendance Report
                        </Link>
                      </div>
                      {/* <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/messages" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faComment} className="laftNavIcon "/>
                          Messages
                        </Link>
                      </div> */}

                     

                      {/* <p className='mobileMenuTitles'>RESEARCH & DEV</p>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/assigned-profects" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faCoffee} className="laftNavIcon"/>
                          Projects Hub
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/startups" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faLightbulb} className="laftNavIcon"/>
                          My Startups
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/startup-corner" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faBriefcase} className="laftNavIcon "/>
                          Startup Corner
                        </Link>
                      </div>

                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/job-board" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faBuilding} className="laftNavIcon "/>
                          Job Board
                        </Link>
                      </div> */}

                      <hr />
                      
                      <div className='leftLinkCont d-flex align-items-center'>
                        <Link to="/profile" className='leftNavLinks '>
                          <FontAwesomeIcon icon={faUser} className="laftNavIcon "/>
                          Profile
                        </Link>
                      </div>
                    </Nav>

                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
          ))}
        </div>

        <div className='searchDashCont' ref={searchDropdownRef}>
          <input
            placeholder='Search pages, courses, invoices...'
            value={searchTerm}
            onFocus={() => {
              setIsMessagesOpen(false);
              setIsNotificationOpen(false);
              setIsProfileMenuOpen(false);
              if (searchTerm.trim()) {
                setIsSearchOpen(true);
              }
            }}
            onChange={(event) => {
              const nextValue = event.target.value;
              setSearchTerm(nextValue);
              setIsSearchOpen(Boolean(nextValue.trim()));
            }}
            onKeyDown={(event) => {
              if (event.key === "Escape") {
                closeSearchDropdown();
                return;
              }
              if (event.key === "Enter" && flatSearchResults.length > 0) {
                event.preventDefault();
                openSearchResult(flatSearchResults[0]);
              }
            }}
          />
          <FontAwesomeIcon icon={faSearch} className="dashSearchIcon "/>

          {isSearchOpen && (
            <div className='dashSearchDropdown'>
              {groupedSearchResults.length === 0 ? (
                <div className='dashSearchEmpty'>
                  No matches found for "{searchTerm}".
                </div>
              ) : (
                groupedSearchResults.map((group) => (
                  <div key={group.name} className='dashSearchGroup'>
                    <div className='dashSearchGroupTitle'>{group.name}</div>
                    <div className='dashSearchGroupList'>
                      {group.items.map((result) => (
                        <button
                          key={result.id}
                          type="button"
                          className='dashSearchResult'
                          onClick={() => openSearchResult(result)}
                        >
                          <div className='dashSearchResultMain'>
                            <strong>{result.title}</strong>
                            <p>{result.description}</p>
                          </div>
                          {result.meta && (
                            <span className='dashSearchResultMeta'>{result.meta}</span>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* <button className='btn btn-warning'>{unreadCount > 0 && <a className='btn btn-primary'>{unreadCount}</a>}</button>
         */}

        <div className='allNotifCont'>

          <div className='messageDropdownWrap' ref={messagesDropdownRef}>
          <button
            type="button"
            className='chatCont messageToggleBtn'
            onClick={() => {
              setIsNotificationOpen(false);
              setIsProfileMenuOpen(false);
              setIsMessagesOpen((currentValue) => !currentValue);
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} className="dashNoticIcon "/>
            <p className='notifCounter'>{unreadCount}</p>
          </button>
          {isMessagesOpen && (
            <div className='messageDropdownMenu'>
              <div className='messageDropdownHeader'>
                <h6>New Messages</h6>
                <span>{unreadMessages.length} chat{unreadMessages.length === 1 ? '' : 's'}</span>
              </div>
              <div className='messageDropdownBody'>
                {unreadMessages.length === 0 ? (
                  <div className='messageDropdownEmpty'>
                    No unread messages right now.
                  </div>
                ) : (
                  unreadMessages.map((message) => (
                    <button
                      key={message.userId}
                      type="button"
                      className='messageDropdownItem'
                      onClick={() => openMessageThread(message)}
                    >
                      <img src={message.avatar} alt={message.name} className='messageDropdownAvatar' />
                      <div className='messageDropdownContent'>
                        <div className='messageDropdownTop'>
                          <strong>{message.name}</strong>
                          <span>{formatMessageTime(message.timestamp)}</span>
                        </div>
                        <p>{formatMessagePreview(message.preview) || message.course || "Open conversation"}</p>
                      </div>
                      <span className='messageDropdownUnread'>{message.unreadCount}</span>
                    </button>
                  ))
                )}
              </div>
            </div>
          )}
          </div>
          <div className='notifDropdownWrap' ref={notificationDropdownRef}>
          <button
            type="button"
            className='NotifCont notifToggleBtn'
            onClick={() => {
              setIsMessagesOpen(false);
              setIsProfileMenuOpen(false);
              setIsNotificationOpen((currentValue) => !currentValue);
            }}
          >
            <FontAwesomeIcon icon={faBell} className="dashNoticIcon "/>
            <p className='notifCounter2'>{totalNotificationCount}</p>
          </button>
          {isNotificationOpen && (
            <div className='notifDropdownMenu'>
              <div className='notifDropdownHeader'>
                <h6>Notifications</h6>
                <span>{totalNotificationCount} alert{totalNotificationCount === 1 ? '' : 's'}</span>
              </div>
              <div className='notifDropdownBody'>
                {totalNotificationCount === 0 ? (
                  <div className='notifDropdownEmpty'>
                    No new notifications right now.
                  </div>
                ) : (
                  <>
                    {assignmentNotifications.length > 0 && (
                      <>
                        <div className='notifDropdownSectionHeader'>Assignments</div>
                        {assignmentNotifications.map((notification) => (
                          <button
                            key={notification.id}
                            type="button"
                            className='notifDropdownItem'
                            onClick={() => openAssignmentNotification(notification)}
                          >
                            <div className='notifDropdownItemTop'>
                              <strong>{notification.title}</strong>
                              <span className='notifStatusBadge notifStatusBadgeAssignment'>
                                Unread
                              </span>
                            </div>
                            <p>{notification.message}</p>
                            <div className='notifDropdownItemMeta'>
                              <span>{notification.courseName}</span>
                              <span>{notification.dueLabel ? `Due ${notification.dueLabel}` : `Posted ${notification.createdLabel}`}</span>
                            </div>
                          </button>
                        ))}
                      </>
                    )}

                    {dueNotifications.length > 0 && (
                      <>
                        <div className='notifDropdownSectionHeader'>School Fee</div>
                        {dueNotifications.map((notification) => (
                          <button
                            key={notification.id}
                            type="button"
                            className='notifDropdownItem'
                            onClick={() => goToFeeInvoices(notification)}
                          >
                            <div className='notifDropdownItemTop'>
                              <strong>{notification.month}</strong>
                              <span className={`notifStatusBadge notifStatusBadge${notification.status.replace(/\s+/g, '')}`}>
                                {notification.status}
                              </span>
                            </div>
                            <p>{notification.message}</p>
                            <div className='notifDropdownItemMeta'>
                              <span>{notification.courseName}</span>
                              <span>Due {notification.dueLabel}</span>
                            </div>
                          </button>
                        ))}
                      </>
                    )}
                  </>
                )}
              </div>
              {assignmentNotifications.length > 0 && (
                <button
                  type="button"
                  className='notifDropdownFooter'
                  onClick={() => {
                    setIsNotificationOpen(false);
                    navigate('/academic');
                  }}
                >
                  Open my courses
                </button>
              )}
              {dueNotifications.length > 0 && (
                <button
                  type="button"
                  className='notifDropdownFooter'
                  onClick={() => {
                    setIsNotificationOpen(false);
                    navigate('/fee-invoices');
                  }}
                >
                  Open fee invoices
                </button>
              )}
            </div>
          )}
          </div>
          <div className='profileDropdownWrap' ref={profileDropdownRef}>
            <button
              type="button"
              className='profCont profileToggleBtn'
              onClick={() => {
                setIsMessagesOpen(false);
                setIsNotificationOpen(false);
                setIsProfileMenuOpen((currentValue) => !currentValue);
              }}
            >
              <img src={userProfilePicture} alt="" />
            </button>
            {isProfileMenuOpen && (
              <div className='profileDropdownMenu'>
                <button type="button" className='profileDropdownItem' onClick={goToEditProfile}>
                  Edit Account
                </button>
                <button type="button" className='profileDropdownItem' onClick={goToProfile}>
                  My Account
                </button>
                <button type="button" className='profileDropdownItem profileDropdownItemDanger' onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
          

        </div>
        <div className='mobileBottomNav'>
          <NavLink to="/dashboard" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
            <FontAwesomeIcon icon={faHome} />
            <span>Home</span>
          </NavLink>
          <NavLink to="/academic" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
            <FontAwesomeIcon icon={faBicycle} />
            <span>Courses</span>
          </NavLink>
          <NavLink to="/my-rooms" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
            <FontAwesomeIcon icon={faVideoCamera} />
            <span>Live</span>
          </NavLink>
          <NavLink to="/fee-invoices" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
            <FontAwesomeIcon icon={faFileInvoice} />
            <span>Invoices</span>
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => `mobileBottomNavLink ${isActive ? "mobileBottomNavLinkActive" : ""}`}>
            <FontAwesomeIcon icon={faUser} />
            <span>Profile</span>
          </NavLink>
        </div>
  </div>
  )
}

export default Dashnav
